module.exports = __webpack_public_path__ + "img/icon_logo.e04e2556.png";